"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKENS = exports.ARR_TITLE_TYPES = exports.TITLE_TYPES = exports.TITLE_ALIGN = void 0;
var TITLE_ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
exports.TITLE_ALIGN = TITLE_ALIGN;
var TITLE_TYPES = {
  HERO_BANNER: 'heroBanner',
  H1: 'h1',
  H2: 'h2',
  H3: 'h3'
};
exports.TITLE_TYPES = TITLE_TYPES;
var ARR_TITLE_TYPES = Object.values(TITLE_TYPES);
exports.ARR_TITLE_TYPES = ARR_TITLE_TYPES;
var TOKENS = {
  weightHeading: 'weightHeading',
  sizeHeading: 'sizeHeading',
  lineHeight: 'lineHeight'
};
exports.TOKENS = TOKENS;